import faFlag from "icons/solid/flag.svg";
import Icon from "hardcover-ui/components/Icon";
import { UserBookSerializersUserBookReview } from "types/serializers";
import ReportButton from "components/ReportDropdown/Report/ReportButton";

export default function FlagReviewButton({
  userBook,
}: {
  userBook: UserBookSerializersUserBookReview;
}) {
  return (
    <ReportButton
      objectId={userBook.id}
      objectType="UserBook"
      description={`Review: #${userBook.id}`}
      variant="ghost"
      size="sm"
    >
      <span className="sr-only">Report this review</span>
      <Icon icon={faFlag} size="md" />
    </ReportButton>
  );
}
